import EfVideo from '@elem/ui/ef-video';
import { useEffect, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';

const IconRePlay = (props: any) => {
    return (
        <div {...props}>
            <span>Replay</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                    d="M10.1588 10.6681C9.27999 11.5469 8.06593 12.0904 6.7249 12.0904C4.04288 12.0904 1.86865 9.91621 1.86865 7.23418C1.86865 4.55215 4.04288 2.37793 6.7249 2.37793C8.06593 2.37793 9.27999 2.92148 10.1588 3.8003C10.6061 4.24761 11.5812 5.34564 11.5812 5.34564"
                    stroke="#999999"
                    strokeWidth="0.925"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.5814 2.91748V5.34561H9.15332" stroke="#999999" strokeWidth="0.925" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
};

export default function TheComp() {
    const { isPC, isDesktop, isPad, isH5 } = useMediaDevice();
    const { t } = useLang('delta_pro_ultra.launch.detail.SmartInsights');
    const [startPlay, setStartPlay] = useState(false);

    const { locale = 'us' } = useRouter();

    const imgItems: {
        [key: string]: any;
    } = {
        us: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439413/SmartInsights2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615542243/SmartInsights2-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439760/SmartInsights3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439243/SmartInsights3-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615439049/SmartInsights4.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439596/SmartInsights4-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735615528124/SmartInsights5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735615439948/SmartInsights5-h5.jpg',
            ],
        ],
    };
    const list = [
        {
            title: t('card1_title'),
            type: 'video',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1735633368781/SmartInsights-1.mp4',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1735788893348/smart_insight.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1735789040206/smart_insight_M.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1735633379708/SmartInsights-1-h5.mp4',
        },
        {
            title: t('card2_title'),
            pc: imgItems[locale][0][0],
            h5: imgItems[locale][0][1],
        },
        {
            title: t('card3_title'),
            pc: imgItems[locale][1][0],
            h5: imgItems[locale][1][1],
        },
    ];
    const [loaderVideo, setLoaderVideo] = useState(true);

    // 进入模块视频播放
    useEffect(() => {
        const callback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setStartPlay(true);
                }
            });
        };
        const play = new IntersectionObserver(callback, {
            threshold: 0.1,
        });
        play.observe(document.querySelector('#SmartInsights') as HTMLDivElement);

        return () => {
            play.disconnect();
        };
    }, []);

    return (
        <div className={`${styles.TheComp}`} id="SmartInsights">
            <div className="smart-insights-content">
                <div className="smart-insights-title">{t('title')}</div>
                <div className="smart-insights-cards">
                    {list.map((i, idx) => (
                        <div className={`smart-insights-card card-${idx + 1}`} key={idx}>
                            <div className="smart-insights-card-info">
                                <div className="smart-insights-card-title">{i.title}</div>
                                {i.desc && <div className="smart-insights-card-desc">{i.desc}</div>}
                            </div>

                            {i.type === 'video' ? (
                                loaderVideo &&
                                (isPC || isDesktop ? (
                                    <EfVideo
                                        className="SmartInsights-video"
                                        startPlay={startPlay}
                                        poster={i.posterPC}
                                        pc={i.pc}
                                        Icon={IconRePlay}
                                        preload="none"
                                    />
                                ) : (
                                    <EfVideo
                                        className="SmartInsights-video"
                                        startPlay={startPlay}
                                        pc={i.h5}
                                        poster={i.posterH5}
                                        Icon={IconRePlay}
                                        preload="none"
                                    />
                                ))
                            ) : (
                                <EfImg className="SmartInsights-img" pc={i.pc as string} h5={i.h5} />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
